import styled from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  row-gap: ${({ theme }) => theme.space["space-1"]};

  &:is(:empty) {
    display: none;
  }

  @media screen and ${breakpoints.tablet.max.sm} {
    &:not(:empty) + div {
      margin-left: ${({ theme }) => theme.space["space-1"]};
    }
  }

  @media screen and ${breakpoints.tablet.min.sm} {
    width: 100%;

    & > button {
      align-self: flex-end;
    }
  }
`;
